import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsEncyclopediaCategory } from 'types/cms/collection-types'
import { stringify } from 'qs'

/**
 * Get the encyclopedia category from the CMS for the given slug
 *
 * @param {string} slug
 * @param {Language} locale
 * @returns {Promise<CmsEncyclopediaCategory | undefined>}
 */
const getEncyclopediaCategoryBySlug = async (
  slug: string,
  locale: Language = Language.DUTCH
): Promise<CmsEncyclopediaCategory | undefined> => {
  try {
    const query = stringify({
      locale
    })

    const { data } = await axios.get<CMSApiResponseBody<CmsEncyclopediaCategory>>(
      `${process.env.CMS_API_URL}/encyclopedia-category/${slug}?${query}`
    )

    return data.data
  } catch (_) {
    return undefined
  }
}

export default getEncyclopediaCategoryBySlug
